import type { BombiixChipVariant } from '../Components/BombiixChip';

export const BOM_V2_ROUTES = {
  TYPE_LIBRARY: '/v2/libraries/bom-type',
  LIBRARY: '/v2/libraries/bom-library/:bomTypeId',
  TYPE_GROUPS: '/v2/libraries/bom-type-group',
  TYPE_GROUP_NEW: '/v2/libraries/bom-type-group/add',
  TYPE_GROUP_EDIT: '/v2/libraries/bom-type-group/edit/:groupId',
  LIBRARY_GROUPS: '/v2/libraries/bom-library-group/:bomTypeId',
  LIBRARY_GROUP_NEW: '/v2/libraries/bom-library-group/add/:bomTypeId',
  LIBRARY_GROUP_EDIT: '/v2/libraries/bom-library-group/edit/:bomTypeId/:groupId',
  LIBRARY_COMPONENT_NEW: '/v2/libraries/bom-library/add/:bomTypeId',
  LIBRARY_COMPONENT_EDIT: '/v2/libraries/bom-library/edit/:bomTypeId/:componentId',
} as const;

export const BOM_V2_TYPE_PAGE_SIZE = 20;

export const BOM_V2_GROUP_PAGE_SIZE = 15;

export const BOM_V2_LIBRARY_PAGE_SIZE = 20;

export const BOM_V2_LIBRARY_GROUP_PAGE_SIZE = 20;

export const BOM_V2_VISIBLE_PRODUCT_TYPES = 3;

export const BOM_V2_VISIBLE_BOM_TYPES = 3;

export const BOM_V2_I18N_NAMESPACE = 'modules/bom';

export const BOM_V2_ADDITIONAL_INFO_ROWS = 5;

export const BOM_V2_ADDITIONAL_INFO_MIN_HEIGHT = 96;

/**
 * Width of the BOM Type form side panel. `BombiixSidePanel` defaults to 504px,
 * which leaves 455px of body once the 24px insets are taken — under the ~476px
 * the rich-text toolbar needs for its label plus eleven controls on one row, so
 * CKEditor collapsed the tail into its overflow menu. 600px clears it.
 */
export const BOM_V2_FORM_PANEL_WIDTH = 600;

/**
 * Character cap on every V2 Additional Information field. The legacy BOM Type
 * Group form carried no cap at all, and the legacy BOM Library allows 5000;
 * V2 settles on 2000 across both forms.
 */
export const BOM_V2_ADDITIONAL_INFO_MAX_LENGTH = 2000;

export const BOM_V2_VISIBLE_CATEGORIES = 3;

/** Category tiers, in the order the four dropdowns cascade. */
export const BOM_V2_CATEGORY_TIERS = [1, 2, 3, 4] as const;

/** Debounce for the BOM library import search, in milliseconds. */
export const BOM_V2_SEARCH_DEBOUNCE_MS = 350;

/**
 * Style for every V2 card grid's `InfiniteScroll`. The library hardcodes
 * `overflow: auto` on its wrapper and merges `style` over it, which clipped the
 * first card row's thumbnail: it sits 18px above the card's top edge, outside
 * the wrapper's content box.
 */
export const BOM_V2_INFINITE_SCROLL_STYLE = { overflow: 'visible' } as const;

/**
 * Character cap on a Library component's Supporting Comments — the V1 BOM Library limit
 * (`BomProvider/filedPaths.js` `ADDITIONAL_INFO_MAX_LENGTH`), kept for parity.
 */
export const BOM_V2_SUPPORTING_COMMENTS_MAX_LENGTH = 5000;

/** Character cap on a component or sub-BOM code in the V2 form. */
export const BOM_V2_CODE_MAX_LENGTH = 100;

/** Character cap on a component or sub-BOM description — the V1 BOM Library limit. */
export const BOM_V2_DESCRIPTION_MAX_LENGTH = 200;

export const PRODUCT_BOM_V2_ROUTES = {
  PAGE: '/v2/development-order/:devOrderId/bom/:supplierId?',
  IMPORT: '/v2/development-order/:devOrderId/bom/import',
  COMPONENT_NEW: '/v2/development-order/:devOrderId/bom/add/:bomTypeId/:supplierId?',
  COMPONENT_EDIT: '/v2/development-order/:devOrderId/bom/edit/:componentId/:supplierId?',
} as const;

/** The swatch colours of a product's supplier tabs, by the supplier's position on the order. */
export const PRODUCT_BOM_V2_SUPPLIER_COLOURS: readonly BombiixChipVariant[] = ['pink', 'purple', 'khaki', 'blue', 'green', 'amber', 'orange', 'red', 'grey'];

/** Temporary rollout flag: the BOM V2 screens open only when the build sets `REACT_APP_BOM_V2_ENABLED=true`. */
export const BOM_V2_ENABLED = process.env.REACT_APP_BOM_V2_ENABLED === 'true';
